/** Residential dwelling types for listings filters (excludes cave/commercial/basement/studio). */
export const RESIDENTIAL_UNIT_TYPE_OPTIONS = [
  { value: 'apartment', label: 'filters.unitType.options.apartment' },
  { value: 'condo', label: 'filters.unitType.options.condo' },
  { value: 'house', label: 'filters.unitType.options.house' },
  { value: 'loft', label: 'filters.unitType.options.loft' },
  { value: 'duplexTriplex', label: 'filters.unitType.options.duplexTriplex' },
  { value: 'townhouse', label: 'filters.unitType.options.townhouse' },
  { value: 'room', label: 'filters.unitType.options.room' },
] as const

export type ResidentialUnitType = (typeof RESIDENTIAL_UNIT_TYPE_OPTIONS)[number]['value']
